import React from 'react';
import CostTrend from './components/CostTrend';
import EnergyConsumptionTrends from './components/EnergyConsumptionTrends';
import UseWaterEnergyFlow from './components/UseWaterEnergyFlow';
import styles from './index.module.scss';
import UnrestoredAlarm from './components/UnrestoredAlarm';

const WaterUsageOverview = () => {
  return (
    <div className={styles.container}>
      {/* 成本趋势 */}
      <CostTrend />
      {/* 用能趋势 */}
      <EnergyConsumptionTrends />

      <UnrestoredAlarm />
      {/* 用水能流概览 */}
      {/* <UseWaterEnergyFlow /> */}
    </div>
  );
};

export default WaterUsageOverview;
